import React, { useEffect, useState } from 'react'
import downloadIcon from '../../assets/images/download.svg'
import myProfileBackgroundImage from '../../assets/images/myProfileBackgroundImage.png'
import circleImageMyProfile from '../../assets/images/circleImageMyProfile.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import FileOutlineIcon from '@mui/icons-material/Description';
import { getDate } from '../../helpers/helperFunction'
import { fetchPartnerProfileById, fetchPartnerProfileCertificateDetails } from '../../redux/partnerProfileSlice'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const ReviewPartnerProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const companyDetails = []
    const partnerProfileData = useSelector((state) => state.partnerProfile.partnerProfileDetailsById);
    const myProfileCertificateData = useSelector((state) => state.partnerProfile.partnerProfileCertificateData);
    const userDetails = useSelector(state => state.auth.userDetails) || {}
    const loading = useSelector((state) => state.myProfile.loading);
    const error = useSelector((state) => state.myProfile.error);
    const { companyId } = useParams();
    
    useEffect(() => {
        // const companyId = userDetails.company?.companyKeyId;
        const url = `/companies/${companyId}`;
        const certificateUrl = `/companies/${companyId}`
        if (companyId) {
            dispatch(fetchPartnerProfileById(url)).then(() => {
            });
        }
        const queryParams = { type: "certificates", pageNumber: 1, pageSize: 12 }
        dispatch(fetchPartnerProfileCertificateDetails({ companyId, queryParams }))
    }, [dispatch]);

    const downloadCompanyCerFun = () => {
        // Code will be wriiten inside this function to download Certificate, after the completion of AB part
    }

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
    };
    return (
        <>
            <nav aria-label="breadcrumb" className="bread-box">
                <div>
                    <h1 className="fprimary">Company Profile </h1>
                </div>
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item me-2"><a href="#">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Company Profile</li>
                    </ol>
                </div>
            </nav>
            <div className="row mt-4 ps-3 pe-3">
                <div className="mb-3" style={{ display: 'flex', flexDirection: 'column', backgroundImage: `url(${myProfileBackgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', minHeight: '25rem' }}>
                    <div style={{ flex: '1' }}></div>
                    <div className="cir-box-bottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', backgroundImage: `url(${circleImageMyProfile})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '200px', height: '200px' }}>
                    </div>
                </div>
                <div className='col-md-12 d-flex justify-content-end'>
                    <Button
                        aria-controls="export-menu"
                        aria-haspopup="true"
                        // variant="contained"
                        style={{ backgroundColor: '#6AA13C' }}
                        className='btn btn-primary greeen-btn md_btn  '
                        startIcon={<FileOutlineIcon />}
                    >
                        Export as PDF
                    </Button>
                </div>
            </div>

            <div className="card mt-3 bg-stage mb-4">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-2">
                            <h1 className="fprimary">Company Details</h1>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2 overflowHandle">
                                    <p className="font-13 mb-0">Company name</p>
                                    <div className="bg-slash font-14 overflowHandle">{partnerProfileData?.companyName || ''}</div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">Company Type</p>
                                    <div className="bg-slash font-14">{partnerProfileData.companyTypeName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">

                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Company URL</p>
                                    <div className="bg-slash font-14">{partnerProfileData?.url || '-'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-5 ml-2'>
                        <h1 className="fprimary">Company Description:</h1>
                        <p className='mt-4'>{partnerProfileData?.description || '-'}</p>
                    </div>
                    <div className='mt-5 ml-2'>
                        <h1 className="fprimary">Address</h1>
                        <p className='mt-4'>{partnerProfileData?.address || '-'}</p>
                    </div>
                </div>
            </div>

            <div className="card mt-3 bg-stage">
                {/* Contact Details */}
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Contact Details</h1>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Mobile No.</p>
                                    <div className="bg-slash font-14">{partnerProfileData?.phoneNumber || "-"}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Additional Mobile No.</p>
                                    <div className="bg-slash font-14">{partnerProfileData.user?.additionalPhone || "-"}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect overflowHandle">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Email-id</p>
                                    <div className="bg-slash font-14 overflowHandle">{partnerProfileData?.emailAddress || "-"}</div>
                                </div>
                                <div className="ps-2 right-box w-100 overflowHandle">
                                    <p className="font-13 mb-0">Addition Email Id</p>
                                    <div className="bg-slash font-14 overflowHandle">{partnerProfileData?.additionalEmail || "-"}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">GST/ VAT/ Tax id *</p>
                                    <div className="bg-slash font-14">{partnerProfileData.gst || "-"}</div>
                                    {/* <span className="ms-2"><img src={linkIcon} alt="Link" /></span> */}
                                </div>
                            </div>
                        </div>
                        <div className='mt-5 ml-2'>
                            <h1 className="fprimary">Awards</h1>
                            <p className='mt-4'>{partnerProfileData?.awards || "-"}</p>
                        </div>

                    </div>
                </div>

            </div>
            <div className="row mt-4 mb-4">
                {myProfileCertificateData.length > 0 ? (
                    <div className="col-md-12 mb-5">
                        <div className='mb-3 mt-2'>
                            <h1 className="fprimary">Certificate Details</h1>
                        </div>
                        <Carousel responsive={responsive}>
                            {myProfileCertificateData.map((certificate, index) => (
                                <div className="" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'normal', marginTop: '35px' }}>
                                    <div className="card bg-leves m-1" key={index} style={{ width: '90%', minWidth: '300px' }}>

                                        <div className="card-body">
                                            <div className="certificate-card">
                                                <div className="cir-box"></div>
                                                <div className="content-box text-center mt-5">
                                                    <h4 className="font-16 mb-1">{certificate.certificateName}</h4>
                                                    <h6>{certificate.certificateIssuingBodyName}</h6>
                                                    <p>
                                                        {certificate.dateOfIssue && getDate(certificate.dateOfIssue) || ''}
                                                        &nbsp;To&nbsp;
                                                        {certificate.dateOfExpiry && getDate(certificate.dateOfExpiry) || ''}
                                                    </p>
                                                    <button className="icon-clay me-2" onClick={() => downloadCompanyCerFun(companyDetails.orderId, 'edit')}>
                                                        <img src={downloadIcon} alt="Download Certificate" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>))
                            }

                        </Carousel>
                    </div>
                ) : <>
                    <div className='mb-3 mt-2'>
                        <h1 className="fprimary">Certificate Details</h1>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2 overflowHandle">
                                    <div className="bg-slash font-14 overflowHandle">No Certificate Found!</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
            </div>
        </>
    )
}

export default ReviewPartnerProfile;